import { useQueries } from '@tanstack/react-query';

import type { TCheckCountQuery } from '@/services/verification';

import { VERIFICATION_KEYS } from '@/constants/queryKeys';
import { errorUtils } from '@/services/errors';
import { verificationService } from '@/services/verification';
import { useStaffSession } from '@/hooks/auth';

type TCheckCountFacet = {
  key: string;
  query: TCheckCountQuery;
};

type TCheckCounts = Record<string, number | undefined>;

const useCheckCounts = (facets: readonly TCheckCountFacet[], isEnabled: boolean = true): TCheckCounts => {
  const { data: session } = useStaffSession();

  const results = useQueries({
    queries: facets.map(facet => ({
      queryKey: VERIFICATION_KEYS.count(facet.query),
      queryFn: async () => errorUtils.unwrap(await verificationService.countChecks(facet.query)),
      enabled: isEnabled && session?.stage === 'ready',
    })),
  });

  return Object.fromEntries(facets.map((facet, index) => [facet.key, results[index]?.data]));
};

export type {
  TCheckCountFacet,
  TCheckCounts,
};
export {
  useCheckCounts,
};
